<template>
    <div>
        <InputRadio
            v-model="formSearch"
            key="input-category"
            ref="radioCategory"
            :setValue="formSearch"
            :inputLbl="lbl.radioCategory"
            :itemList="categoryListValue"
            :isFirstSave="true"
            :isShowErrorLbl="true"
            :errorInfo="errorInfo[0]"
            @input="clickCategory(formSearch, $event)"
        ></InputRadio>
    </div>
</template>
<script>
//base
import Account from "@/helper/AccountHelper.js";
import Locale from "@/helper/locale/Locale.js";
//core
import { CategoryConfigBuilder } from "@/service/config/CategoryConfigModel.js"
//service
import BzbsCategory from "@/service/BzbsCategory.js";
// import { SearchListModel } from "../../model/SearchListModel";
// components
import InputRadio from "./RadioBox.vue";
// helper
import FormHelper from "@/helper/FormHelper.js";

export default {
    name: 'Category',
    components: {
        InputRadio
    },
    props: {
        locale: Number,
        categoryConfig: String,
        blobConfig: Object,
        busEvent: Object,
        categoryId: Number
    },
    data: function () {
        return {
            lbl: Locale.getLbl().searchList.sidebar,
            selectCategory: {},
            categoryConfigObj: {},
            categories: [],
            // categoriesSplit: [],
            isLoaded: false,
            cateId: [],
            formSearch: null,
            errorInfo: FormHelper.genErrorInfo(1),
            categoryListValue: []
        };
    },
    mounted: function () {
    },
    created: function () {
        this.initialCategory();
    },
    methods: {
        clickCategory: function (category, subCats) {
            let categoriesFilter
            if(typeof subCats === 'object' && subCats !== null) {
                categoriesFilter = this.categories[subCats.idx].subcats.filter(e => e.id === subCats.value)
            }else{
                categoriesFilter = this.categories.filter(e => e.id === category)
            }
            if(categoriesFilter.length === 0) {
                this.selectCategory = this.categories[0]
            }else{
                this.selectCategory = categoriesFilter[0]
            }
            // console.log(`🚀 ~ file: Category.vue:78 ~ this.selectCategory:`, this.selectCategory)
            this.$emit('changeCategory', this.selectCategory);
        },
        initialCategory: function () {
            this.categoryConfigObj = new CategoryConfigBuilder()
                .setConfig(this.categoryConfig)
                .create();

            var categoryParam = this.categoryConfigObj
                .getParams();

            var token = Account.getToken();
            BzbsCategory.apiGetCategory(token, categoryParam)
                .then((categories) => {
                    // console.log(`🚀 ~ file: Category.vue:84 ~ .then ~ categories:`, categories)

                    for (var category of categories) {
                        // console.log(`🚀 ~ file: Category.vue:96 ~ .then ~ category:`, category)
                        if (category.mode == "all") {
                            // index++;
                            this.categories.push(category);
                        } else if (category.id) {
                            // index++;
                            this.categories.push(category);
                        }
                    }
                    
                    // console.log(`🚀 ~ file: Category.vue:112 ~ .then ~ this.categories:`, this.categories)
                    var categoryList = new FormHelper.ItemListValue();
                    for(let i = 0; i < this.categories.length; i++){
                        categoryList.addCustom(
                            this.categories[i].name, 
                            this.categories[i].id, 
                            this.categories[i].subcats
                        );
                    }
                    this.categoryListValue = categoryList.getList();
                    this.isLoaded = true;

                    if (this.categoryId == null){
                        this.clickCategory(this.categoryListValue[0]);
                    } 

                }).catch((error) => {
                    this.isLoaded = true;
                    this.isHaveItem = false;
                    console.log(error);
                });
        },
        clearValue: function() {
            this.formSearch = null
            this.$refs.radioCategory.clearValue()
        }
    }
}
</script>
<style lang="scss" scoped>
    @import "@/style/base/base.scss";
    @import "./Category.scss";

    .bds-container {
        @include min-desktop {
            max-width: $max-container-desktop;
            margin: auto;
        }
    }
</style>
